var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-badge',{class:{ 'cursor-pointer': _vm.admin },attrs:{"color":"grey-3","text-color":"primary"},on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.content)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }